

















































































import VAgentCompanyAssociationDuplicatesAccordion from "@/components/Agents/AgentCompanyAssociationDuplicatesAccordion.vue";
import QueryableInterface from "@/interfaces/QueryableInterface";
import { AgentModuleConfiguration, User } from "@/models";
import AgentModuleConfigurationMixin, {
  AgentModuleConfigurationMixinTags,
} from "@/mixins/http/Agencies/AgentModuleConfigurationMixin";
import AgentCompanyAssociationDuplicatesMixin, {
  AgentCompanyAssociationDuplicateMixinTags,
} from "@/mixins/http/Agents/AgentCompanyAssociationDuplicateMixin";
import AgentMixin, { AgentMixinTags } from "@/mixins/http/Agents/AgentMixin";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import ClientAgent from "@/models/Agents/Agent";
import AgentCompanyAssociationDuplicate from "@/models/Agents/AgentCompanyAssociationDuplicate";
import { Component, Mixins } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import MessagePanel from "@/components/MessagePanel.vue";
import CompanyMixin, {
  AgentsCompanyMixinTags,
} from "@/mixins/http/Agents/Company";
import ClientCompany from "@/models/Agents/Company";
import MatchPrincipalAccordion from "@/components/Agents/MatchPrincipalAccordion.vue";
import ToastInvoker from "@/utils/ToastInvoker";
import NotificationBadge, {
  NotificationBadgeGroups,
} from "@/components/Agents/NotificationBadge.vue";

@Component({
  components: {
    MessagePanel,
    NotificationBadge,
    MatchPrincipalAccordion,
    VAgentCompanyAssociationDuplicatesAccordion,
  },
})
export default class AgentCompanyAssociationDuplicates extends Mixins(
  AgentCompanyAssociationDuplicatesMixin,
  AgentMixin,
  AgentModuleConfigurationMixin,
  CompanyMixin
) {
  @Getter("user") user!: User;
  @Getter("profile") profile!: AdcontrolProfile;

  @Action("notificationsGroups/valorizeCompany")
  readonly valorizeCompanyNotifications!: (notificationCount: number) => void;
  @Action("notificationsGroups/valorizeCompanyAssociationDuplicates")
  readonly valorizeCompanyAssociationDuplicatesNotifications!: (
    notificationCount: number
  ) => void;

  duplicates: AgentCompanyAssociationDuplicate[] = [];
  duplicateSets: { [key: string]: AgentCompanyAssociationDuplicate[] } = {};
  agents: ClientAgent[] = [];
  agentModuleConfiguration: AgentModuleConfiguration | null = null;
  missingPrincipals: string[] = [];
  agentsIndxParams: QueryableInterface = { page: { size: "all" } };

  setKeys: string[] = [];

  get notificationBadgeGroups(): NotificationBadgeGroups[] {
    return this.hasMatchByProduct
      ? [NotificationBadgeGroups.Company]
      : [NotificationBadgeGroups.CompanyAssociationDuplicates];
  }

  get slug() {
    return this.profile.slug.toUpperCase();
  }

  async mounted() {
    this.loadRecords();
  }

  loadRecords() {
    this.valorizeAgentModuleConfiguration();

    this.hasMatchByProduct
      ? this.valorizeCompanies()
      : this.valorizeDuplicates();
  }

  get loading(): boolean {
    const companiesLoading =
      this.$store.getters["http/status"][AgentsCompanyMixinTags.GetCompanies]
        ?.loading ?? false;

    const duplicatesLoading =
      this.$store.getters["http/status"][
        AgentCompanyAssociationDuplicateMixinTags.GetDuplicates
      ]?.loading ?? false;

    const agentModuleConfigurationLoading =
      this.$store.getters["http/status"][
        AgentModuleConfigurationMixinTags.GetAgentModuleConfiguration
      ]?.loading ?? false;

    return (
      companiesLoading || duplicatesLoading || agentModuleConfigurationLoading
    );
  }

  async valorizeDuplicates() {
    this.duplicates = [];
    try {
      this.duplicates = await this.getDuplicates(
        this.profile.slug,
        AgentCompanyAssociationDuplicateMixinTags.GetDuplicates,
        { include: "agent_company,agency,agency_agent,agent_product" }
      );

      this.createDuplicateSets();
      await this.valorizeAgents();
    } catch (e) {
      this.duplicates = [];
      ToastInvoker.errorToast("Errore nel caricamento", e);
    }
  }

  async valorizeAgents() {
    try {
      this.agents = await this.getAgents(
        this.profile.slug,
        AgentMixinTags.GetAgents,
        this.agentsIndxParams
      );
    } catch (error) {
      this.agents = [];
      throw error;
    }
  }

  async valorizeAgentModuleConfiguration() {
    try {
      this.agentModuleConfiguration = await this.getAgentModuleConfiguration(
        AgentModuleConfigurationMixinTags.GetAgentModuleConfiguration,
        this.profile.slug
      );
    } catch (error) {
      this.agentModuleConfiguration = null;
    }
  }

  async valorizeCompanies() {
    this.missingPrincipals = [];
    try {
      await this.getCompanies(
        AgentsCompanyMixinTags.GetCompanies,
        this.profile.slug,
        {
          "filter[with_no_principal]": 1,
          "page[size]": "all",
        }
      ).then((companies) => {
        this.missingPrincipals = [
          ...new Set(companies.map((company: ClientCompany) => company.name)),
        ];
      });
      this.valorizeCompanyNotifications(this.missingPrincipals.length);
    } catch (error) {
      ToastInvoker.errorToast("Errore nel caricamento", error);
    }
  }

  createDuplicateSets() {
    this.duplicateSets = {};

    const generateDuplicateKeyFn = function (
      duplicate: AgentCompanyAssociationDuplicate
    ) {
      return `${duplicate.agentCompanyId}/${
        duplicate.agentProductId ?? "no_product"
      }`;
    };

    this.duplicates.forEach((duplicate) => {
      const key = generateDuplicateKeyFn(duplicate);

      if (this.duplicateSets[key]) {
        this.duplicateSets[key].push(duplicate);
      } else {
        this.duplicateSets[key] = [duplicate];
      }
    });

    this.setKeys = [
      ...new Set(
        this.duplicates.map((duplicate) => generateDuplicateKeyFn(duplicate))
      ),
    ];

    this.setKeys.forEach((setKey) => {
      this.duplicateSets[setKey] = this.duplicateSets[setKey].sort(
        (set) => set.mediaId
      );
    });

    this.valorizeCompanyAssociationDuplicatesNotifications(
      Object.keys(this.duplicateSets).length
    );
  }

  get hasMatchByProduct() {
    return this.hasFeature("agents_match_by_product");
  }

  hasFeature(feature: string) {
    if (!this.user) {
      return false;
    }

    return this.user.hasFeature(feature);
  }

  computeMediaIdsForAgentCompany(agentCompanyId: number): Array<number> {
    return [
      ...new Set(
        this.duplicateSets[agentCompanyId].map((duplicate) => duplicate.mediaId)
      ),
    ].sort();
  }

  onSaved(duplicatesToMatch: AgentCompanyAssociationDuplicate[]) {
    this.duplicates = [...duplicatesToMatch];
    this.createDuplicateSets();
  }
}
